import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { ServicesSharedModule } from 'src/app/services/services-shared.module';
import { GameTransactionsComponent } from './game-transactions.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateTimestampFormatPipe } from 'src/app/pipes/date-timestamp-format.pipe';


@NgModule({
  declarations: [
    GameTransactionsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    ServicesSharedModule,
    NgxPaginationModule,
    DateTimestampFormatPipe
  ]
})
export class GameTransactionsModule {}